import { ValidatorFn, Validators } from '@angular/forms';
import { minDateValidator } from 'src/app/shared/validators/min-date.validator';
import { IdentityDocumentTypeEnum } from '../enums/IdentityDocumentTypeEnum';
import { PassportValidator } from '../../shared/validators/passport.validator';

interface IdentityDocumentValidationProperties {
  serialValidation: ValidatorFn[];
  numberValidation: ValidatorFn[];
  expirationDateValidation: ValidatorFn[];
  serialLength?: number;
  numberLength?: number;
}

export class IdentityDocumentConstants {
  static getDocumentValidatorsMap(): Map<IdentityDocumentTypeEnum, IdentityDocumentValidationProperties> {
    const defaultSerialLength = 4;
    const defaultNumberLength = 6;

    return new Map<IdentityDocumentTypeEnum, IdentityDocumentValidationProperties>([
      [
        IdentityDocumentTypeEnum.Undefined,
        {
          serialValidation: [],
          numberValidation: [],
          expirationDateValidation: [],
          serialLength: defaultSerialLength,
          numberLength: defaultNumberLength,
        },
      ],
      [
        IdentityDocumentTypeEnum.Passport,
        {
          serialValidation: [],
          numberValidation: [Validators.required, PassportValidator()],
          expirationDateValidation: [Validators.required, minDateValidator(new Date())],
          serialLength: 0,
          numberLength: 14,
        },
      ],
      [
        IdentityDocumentTypeEnum.OtherIdentityDocument,
        {
          serialValidation: [],
          numberValidation: [Validators.required, Validators.pattern(/^-?([A-Za-z0-9-\/]*)?$/), Validators.minLength(3), Validators.maxLength(20)],
          expirationDateValidation: [Validators.required, minDateValidator(new Date())],
          serialLength: 0,
          numberLength: 20,
        },
      ],
    ]);
  }
}
